import { Button } from '@material-ui/core';
import React from 'react';
import { translate } from 'react-jhipster';
import './claim-declare-step-actions.scss';

const StepActionsVertical = (props) => {
    const { getNextView, disabledNext } = props;
    return (
        <div className="row-buttonRow">
            <div className="content-stepActionsVertical" >
                <Button tabIndex={0}
                    onClick={getNextView}
                    variant="contained"
                    className="btn btn-block button"
                    disableElevation
                    disabled={disabledNext}>
                    <span>{translate("settings.button.valid")}</span>
                </Button>
            </div>
        </div>
    );
};


export default StepActionsVertical;
